import React from 'react'

import Page from '../../../components/pdf/Page'
import Content from './_shared/Content'

const PdfDocument = () => {
  return (
    <Page>
      <Content />
    </Page>
  )
}

export default PdfDocument
